import { enumNumbersToOptions } from '@libs/types/src/common/enum/util';

export enum EducationCodeEnum {
    NoEducation = 1,
    Primary = 2,
    SecondaryWithCertificate = 3,
    SecondaryWithDiploma = 4,
    HigherProfessional = 5,
    BachelorDegree = 6,
    MasterDegree = 7
}

export const educationCodeToEnumOptions = enumNumbersToOptions(EducationCodeEnum, 'user.common.education.');

